const Popup = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'Menu_GeneralSettings',
        },
        options: {
          popupImage: {
            type: 'ImageUploader',
            order: 1,
          },
          isShowBorder: {
            type: 'Toggle',
            order: 2,
            renderOptions: {
              controlKey: 'isShowBorder',
            },
          },
          borderColor: {
            type: 'HexColor',
            order: 3,
          },
          popupBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 4,
          },
          imageBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 5,
          },
          backgroundColor: {
            type: 'HexColor',
            order: 6,
          },
          padding: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'edge',
            },
            type: 'FourPx',
            order: 7,
          },
        },
      },
      Menu_PopupButtonSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'Menu_PopupButtonSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isShowPopupButton',
            },
            options: {
              buttonWidths: {
                type: 'RangeNumber',
                data: {
                  max: 100,
                  min: 10,
                  step: 1,
                },
                order: 2,
              },
              buttonVerticalPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'RangeNumber',
                order: 3,
              },
              firstButtonText: {
                type: 'Text',
                order: 3,
              },
              firstButtonBackgroundColor: {
                type: 'HexColor',
                order: 4,
              },
              firstButtonTextSize: {
                order: 5,
                type: 'RangePx',
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                },
              },
              firstButtonTextWeight: {
                order: 6,
                type: 'SelectBox',
                data: {
                  selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                },
              },
              firstButtonTextColor: {
                order: 7,
                type: 'HexColor',
              },
              firstButtonBorderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
                order: 8,
              },
              firstButtonBorderColor: {
                type: 'HexColor',
                order: 7,
              },
              firstButtonPointTo: {
                type: 'Linking',
                order: 1,

              },
              'widget.Popup.buttonCount': {
                type: 'ToggleRadioTabs',
                order: 8,
                renderOptions: {
                  controlKey: 'buttonCount',
                  direction: 'row',
                },
                options: {
                  singleButtonPosition: {
                    type: 'LeftCenterRight',
                    order: 2,
                  },
                  'widget.Popup.buttonCount': {
                    type: 'Group',
                    order: 200,
                    renderOptions: {
                      controlKey: 'Group_MultiButton',
                    },
                    options: {
                      secondButtonText: {
                        type: 'Text',
                        order: 1,
                      },
                      secondButtonBackgroundColor: {
                        type: 'HexColor',
                        order: 2,
                      },
                      secondButtonTextSize: {
                        order: 3,
                        type: 'RangePx',
                        data: {
                          max: 30,
                          min: 0,
                          step: 1,
                        },
                      },
                      secondButtonTextWeight: {
                        order: 4,
                        type: 'SelectBox',
                        data: {
                          selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
                        },
                      },
                      secondButtonTextColor: {
                        order: 5,
                        type: 'HexColor',
                      },
                      secondButtonBorderRadius: {
                        data: {
                          max: 30,
                          min: 0,
                          step: 1,
                          svgType: 'border',
                        },
                        type: 'FourPx',
                        order: 6,
                      },
                      secondButtonBorderColor: {
                        type: 'HexColor',
                        order: 7,
                      },
                      secondButtonPointTo: {
                        type: 'Linking',
                        order: 1,

                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      Menu_PageTheShow: {
        order: 1,
        type: 'Menu',
        renderOptions: {
          controlKey: 'PageTheShow',
        },
        options: {
          pageTheShow: {
            type: 'Linking',
            order: 1,
            data: {
              hideSections: true,
              allowed: ["defaultPage", "emptyInternalLinking"]
            }
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'Popup_1',
      name: 'Popup_1',
      type: 'Popup',
      data: {},
      customization: {
        popupImage: 'https://d9aff4nz0lkg0.cloudfront.net/popup_image_placeholder.png',
        isShowPopupButton: true,
        buttonCount: 'widget.Popup.buttonCount',
        firstButtonText: 'HERE WITH NEW SEASON',
        firstButtonBackgroundColor: '#DFE3FF',
        firstButtonTextSize: '10px',
        firstButtonTextWeight: '400',
        firstButtonTextColor: '#A2AAFF',
        firstButtonBorderRadius: '30px 30px 30px 30px',
        firstButtonBorderColor: '#DFE3FF',
        firstButtonPointTo: {
          pointTo: {
            pointTo: 'Main',
            pointToType: 'defaultPage',
          },
          internalLinking: true,
        },
        singleButtonPosition: 'right',
        secondButtonText: 'APPLY',
        secondButtonBackgroundColor: '#c6ccff',
        secondButtonTextSize: '10px',
        secondButtonTextWeight: '400',
        secondButtonTextColor: '#A2AAFF',
        secondButtonBorderRadius: '30px 30px 30px 30px',
        secondButtonBorderColor: '#c6ccff',
        secondButtonPointTo: {
          pointTo: {
            pointTo: 'Cart',
            pointToType: 'defaultPage',
          },
          internalLinking: true,
        },
        'widget.Popup.buttonCount': '-',
        buttonWidths: '70',
        buttonVerticalPadding: '2px',
        isShowBorder: true,
        borderColor: '#A2AAFF',
        popupBorderRadius: '25px 25px 25px 25px',
        imageBorderRadius: '20px 20px 20px 20px',
        backgroundColor: '#FFFFFF',
        padding: '15px 15px 15px 15px',
        pageTheShow: {
          pointTo: {
            pointTo: 'emptyInternalLinking',
            pointToType: 'defaultPage',
          },
          internalLinking: true,
        },
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Popup_1_placeholder.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Popup_2',
      name: 'Popup_2',
      type: 'Popup',
      data: {},
      customization: {
        popupImage: 'https://d9aff4nz0lkg0.cloudfront.net/popup_image_placeholder.png',
        isShowPopupButton: true,
        buttonCount: 'widget.Popup.buttonCount',
        firstButtonText: 'HERE WITH NEW SEASON',
        firstButtonBackgroundColor: '#c6ccff',
        firstButtonTextSize: '10px',
        firstButtonTextWeight: '400',
        firstButtonTextColor: '#A2AAFF',
        firstButtonBorderRadius: '30px 30px 30px 30px',
        firstButtonBorderColor: '#DFE3FF',
        singleButtonPosition: 'right',
        secondButtonText: 'APPLY',
        secondButtonBackgroundColor: '#c6ccff',
        secondButtonTextSize: '10px',
        secondButtonTextWeight: '400',
        secondButtonTextColor: '#A2AAFF',
        secondButtonBorderRadius: '30px 30px 30px 30px',
        secondButtonBorderColor: '#c6ccff',
        'widget.Popup.buttonCount': '-',
        buttonWidths: '70',
        buttonVerticalPadding: '2px',
        isShowBorder: true,
        borderColor: '#A2AAFF',
        popupBorderRadius: '25px 25px 25px 25px',
        imageBorderRadius: '20px 20px 20px 20px',
        backgroundColor: '#FFFFFF',
        padding: '15px 15px 15px 15px',
        pageTheShow: {
          pointTo: {
            pointTo: 'Main',
            pointToType: 'defaultPage',
          },
          internalLinking: true,
        },
      },
      variantData: {
        isEditable: true,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
        dynamicRenderTabs: {
          category: 'default',
          brand: 'default',
        },
        dynamicLimitOptions: ['4', '8', '12', '16', '20'],
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Popup_2_placeholder.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};
export default Popup;
